import type { Method } from 'lib/axios';

import { APICallV4 } from '../APICall';

export type AiImprovePathType = 'file' | 'public' | 'attach';

interface RequestData {
    path: string;
    storage_type: AiImprovePathType;
    returnArray?: boolean;
}

export class ImproveImageApiCall extends APICallV4<ArrayBuffer, RequestData> {
    _method = 'improve/image';
    _type: Method = 'post';
    _responseType = 'arraybuffer' as const;
}

export const improveImageApiCall = async (args: RequestData) => {
    const resp = await new ImproveImageApiCall().makeRequest(args);

    const contentType = resp.headers?.['content-type'];

    if (contentType && contentType.includes?.('application/json') && resp.data) {
        const uint8Array = new Uint8Array(resp.data as ArrayBuffer);
        const textDecoder = new TextDecoder('utf-8');

        const decodedString = textDecoder.decode(uint8Array);

        const taskId = JSON.parse(decodedString)?.task_id;

        return { taskId };
    }

    if (contentType && contentType.includes?.('application/octet-stream') && resp.data) {
        return { image: resp.data };
    }
};
